module.exports = __webpack_public_path__ + "img/heatex-N-idle.d7f73ad4.png";